<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-24 09:11:38
 * @LastEditors: Tan Chao
 * @LastEditTime: 2022-10-12 17:24:22
-->
<template>
	<div>11111111111111</div>
</template>

<script>
import schemaMixin from '@/mixin/schemaMixin';
export default {
	name: 'SchemaWechatStore',
	mixins: [schemaMixin],
	data() {
		return {
			cloneValue: {},
		};
	},
	created() {},
	watch: {
		cloneValue: {
			handler(val) {},
			deep: true,
		},
	},
	methods: {},
};
</script>
<style lang="scss" scoped></style>
